import * as React from "react";
import { Form, Modal, Button } from "antd";
import { RouteComponentProps, withRouter, Link } from "react-router-dom";
import { FormComponentProps } from "antd/lib/form";
import StandardButton from 'src/components/common/StandardButton/StandardButton';
import { ExpenseCreateOrEdit } from 'src/components/common/ExpenseCreateOrEdit/ExpenseCreateOrEdit';
import { IExpenseDetail } from 'src/services/interfaces/Expense/IExpenseDetail';
import { useState } from 'react';

interface IInReviewExpenseEditProps extends RouteComponentProps<any>, FormComponentProps {
  expense?: IExpenseDetail;
  reloadExpense?: (expenseId: number) => void;
}

const InReviewExpenseEditButtonForm: React.FC<IInReviewExpenseEditProps> = ({
  expense,
  reloadExpense,
  form
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);

  return (
    <>
      <Button
        className="change-trade-phase btn"
        icon="form"
        onClick={() => setShowModal(true)}
      >
        Editar Solicitação de pagamento
      </Button>

      <Modal
        className="modal-large"
        title={`Editando Solicitação de Pagamento: ${expense.id}`}
        visible={showModal}
        okText="Fechar"
        onOk={() => setShowModal(false)}
        onCancel={() => setShowModal(false)}
      >
        <Form>
          <ExpenseCreateOrEdit
            isCreate={false}
            expenseBase={expense}
            forms={form}
            reloadExpense={reloadExpense}
            buttonToReturn={(
              <StandardButton preset="outline">
                <Link to="/nf-payment/in-review">
                  Voltar
                </Link>
              </StandardButton>
            )}
            onExecuteText={"Salvar Solicitação"}
          />
        </Form>
      </Modal>
    </>
  );
}

export const InReviewExpenseEditButton = withRouter(Form.create()(InReviewExpenseEditButtonForm));


// WEBPACK FOOTER //
// ./src/components/common/InReviewExpenseEditButton/InReviewExpenseEditButton.tsx